import { Button, Form, Icon, Input, Title } from '@fnacdarty/back-office-ui';
import React, { useState } from 'react';
import { useTheme } from 'styled-components';
import { useNavigate } from 'react-router-dom';
import {
	StyledContainer,
	StyledTitleContainer,
	StyledError,
	StyledBlock,
	StyledSuccess,
} from './index.styled';
import { modifyPassword } from '../../utils/auth';
import { useForm } from '../../../../hooks';
import { BrandHeadBar } from '../../../../layouts';

const ChangePassword = () => {
	const theme = useTheme();

	const [showPassword, isPasswordShow] = useState(false);
	const [showNewPassword, isNewPasswordShow] = useState(false);
	const [showConfirmNewPassword, isConfirmNewPasswordShow] = useState(false);
	const [isPasswordChanged, setIsPasswordChanged] = useState(false);
	const [userMail, setUserMail] = useState('none');

	const togglePassword = () => {
		isPasswordShow(!showPassword);
	};

	const toggleNewPassword = () => {
		isNewPasswordShow(!showNewPassword);
	};

	const toggleConfirmNewPassword = () => {
		isConfirmNewPasswordShow(!showConfirmNewPassword);
	};

	const [status, setStatus] = useState({
		loading: false,
		error: '',
		message: '',
	});
	const { formData, handleOnChange } = useForm({
		newPassword: '',
		confirmNewPassword: '',
	});

	const navigate = useNavigate();
	const handleHomeRedirect = () => {
		navigate('/');
	};

	const handleFormSubmit = async (event) => {
		event.preventDefault();

		setStatus({ ...status, loading: true });

		const payload = {
			newPassword: formData.newPassword,
			confirmNewPassword: formData.confirmNewPassword,
		};

		const res = await modifyPassword(payload);
		if (formData.confirmNewPassword !== formData.newPassword) {
			const message = [
				{
					message: 'Les mots de passe ne correspondent pas !',
				},
			];
			return setStatus({
				...status,
				error: message,
				loading: false,
			});
		}
		console.log('res', res);
		if (res.success) {
			setIsPasswordChanged(true);
			setUserMail(res.data.userMail);
		}
		return setStatus({
			...status,
			error: res.message,
			loading: false,
		});
	};

	return (
		<>
			<BrandHeadBar />
			<StyledContainer>
				<StyledTitleContainer>
					<Title level={2}>Modification du mot de passe</Title>
				</StyledTitleContainer>
				{!isPasswordChanged ? (
					<>
						<Form onSubmit={handleFormSubmit}>
							<StyledBlock>
								<Input
									name="newPassword"
									type={showNewPassword ? 'text' : 'password'}
									placeholder="Nouveau mot de passe"
									required
									label="Nouveau mot de passe"
									value={formData.newPassword}
									onChange={handleOnChange}
								/>
								<span
									style={{
										position: 'absolute',
										right: '28px',
										top: '14px',
									}}
								>
									<Icon
										name="eye"
										width={20}
										style={{
											position: 'absolute',
											float: 'right',
										}}
										onClick={toggleNewPassword}
										color={
											showNewPassword
												? theme.colors.primary
												: theme.colors.muted
										}
									/>
								</span>
							</StyledBlock>
							<StyledBlock>
								<Input
									name="confirmNewPassword"
									type={
										showConfirmNewPassword
											? 'text'
											: 'password'
									}
									placeholder="Confirmer mot de passe"
									required
									label="Confirmer nouveau mot de passe"
									value={formData.confirmNewPassword}
									onChange={handleOnChange}
								/>
								<span
									style={{
										position: 'absolute',
										right: '28px',
										top: '14px',
									}}
								>
									<Icon
										name="eye"
										width={20}
										style={{
											position: 'absolute',
											float: 'right',
										}}
										onClick={toggleConfirmNewPassword}
										color={
											showConfirmNewPassword
												? theme.colors.primary
												: theme.colors.muted
										}
									/>
								</span>
							</StyledBlock>
							<br></br>
							<Button
								type="submit"
								style={{
									backgroundColor: theme.colors.portail,
								}}
							>
								{status.loading ? 'Chargement...' : 'Valider'}
							</Button>
						</Form>
						<Button
							style={{
								backgroundColor: theme.colors.primaryLight,
								marginTop: '6px',
							}}
							onClick={handleHomeRedirect}
						>
							Annuler
						</Button>
						<div>
							Le mot de passe doit être composé au minimum de 8
							caractères,
						</div>
						<div>
							comporter au moins 1 lettre majuscule, 1 lettre
							minuscule, 1 chiffre
						</div>
						<div>et 1 caractère spécial.</div>
					</>
				) : (
					<>
						<StyledSuccess className="succes">
							Votre demande a bien été prise en compte.
						</StyledSuccess>
						<StyledSuccess className="succes">
							Un e-mail vous a été envoyé à
						</StyledSuccess>
						<StyledSuccess className="succes">
							{userMail}
						</StyledSuccess>
						<Button
							style={{ backgroundColor: theme.colors.primary }}
							onClick={handleHomeRedirect}
						>
							Fermer
						</Button>
					</>
				)}
				{status.error
					? status.error.map((item, index) => (
							<StyledError key={index} className="error">
								{item.message}
							</StyledError>
					  ))
					: null}
			</StyledContainer>
		</>
	);
};

export default ChangePassword;
